import { throwError as observableThrowError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TraineeContinuingProfessionalDevelopment } from '../model/trainee_cpd.model';
import { ApiResultModel } from '../model/api_result.model';

import { API_URLS } from '../utils/api_url.util';
import { API_UTILS } from '../utils/api_utils.util';
import { catchError } from 'rxjs/operators';
import { FacultyMandatoryCPD } from '../model/faculty_mandatory_cpd.model';
import { ContinuingProfessionalDevelopmentTypeModel } from '../model/cpd_type.model';

/*
  Generated class for the UserFaculties provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class ContinuingProfessionalDevelopmentService {
	mFacultyMandatoryCPD: FacultyMandatoryCPD;

	constructor(private http: HttpClient) {}

	getAllTraineeContinuingProfessionalDevelopment(
		userId: string
	): Observable<Array<TraineeContinuingProfessionalDevelopment>> {
		let items$ = this.http
			.get<Array<TraineeContinuingProfessionalDevelopment>>(
				API_URLS.API_GET_TRAINEE_CONTINUING_PROFESSIONAL_DEVELOPMENT + `/${userId}`
			)
			.pipe(catchError(handleError));
		return items$;
	}

	getAllMandatoryCPDs(facultyId: string): Observable<Array<FacultyMandatoryCPD>> {
		let items$ = this.http
			.get<Array<FacultyMandatoryCPD>>(API_URLS.API_GET_ALL_MANDATORY_CPDS + `/${facultyId}`)
			.pipe(catchError(handleError));
		return items$;
	}

	getCPDByRef(refNo: string): Observable<TraineeContinuingProfessionalDevelopment> {
		let items$ = this.http
			.get<TraineeContinuingProfessionalDevelopment>(
				API_URLS.API_GET_TRAINEE_CONTINUING_PROFESSIONAL_DEVELOPMENT_BY_REF + `/${refNo}`
			)
			.pipe(catchError(handleError));
		return items$;
	}

	getCPDReports(): Observable<Array<TraineeContinuingProfessionalDevelopment>> {
		let items$ = this.http
			.get<Array<TraineeContinuingProfessionalDevelopment>>(API_URLS.API_GET_CDP_REPORT)
			.pipe(catchError(handleError));
		return items$;
	}

	getTraineeContinuingProfessionalDevelopmentByType(
		userId: string,
		type: number
	): Observable<Array<TraineeContinuingProfessionalDevelopment>> {
		let items$ = this.http
			.get<Array<TraineeContinuingProfessionalDevelopment>>(
				API_URLS.API_GET_TRAINEE_CONTINUING_PROFESSIONAL_DEVELOPMENT_BY_TYPE + `/${userId}` + `/${type}`
			)
			.pipe(catchError(handleError));
		return items$;
	}

	editCPD(item: any): Observable<any> {
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };
		let id = item.Id;

		return this.http.put<any>(API_URLS.API_UPDATE_STUDENT_CPD, body, options).pipe(catchError(handleError));
	}

	addTraineeContinuingProfessionalDevelopment(
		item: TraineeContinuingProfessionalDevelopment
	): Observable<ApiResultModel> {
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };

		let items$ = this.http
			.post<ApiResultModel>(API_URLS.API_POST_ADD_TRAINEE_CONTINUING_PROFESSIONAL_DEVELOPMENT, body, options)
			.pipe(catchError(handleError));
		return items$;
	}

	getCPDTypes(): Observable<Array<ContinuingProfessionalDevelopmentTypeModel>> {
		let items$ = this.http
			.get<Array<ContinuingProfessionalDevelopmentTypeModel>>(API_URLS.API_CPD_TYPE)
			.pipe(catchError(handleError));
		return items$;
	}

	getFacultyMandatoryCPDItems(): Observable<Array<FacultyMandatoryCPD>> {
		let items$ = this.http
			.get<Array<FacultyMandatoryCPD>>(API_URLS.API_FACULTY_MANDATORY_CPD)
			.pipe(catchError(handleError));
		return items$;
	}

	addFacultyMandatoryCPD(item: FacultyMandatoryCPD): Observable<FacultyMandatoryCPD> {
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };
		let items$ = this.http
			.post<FacultyMandatoryCPD>(API_URLS.API_FACULTY_MANDATORY_CPD, body, options)
			.pipe(catchError(handleError));
		return items$;
	}

	editFacultyMandatoryCPD(item: FacultyMandatoryCPD): Observable<FacultyMandatoryCPD> {
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };

		let items$ = this.http
			.put<FacultyMandatoryCPD>(API_URLS.API_FACULTY_MANDATORY_CPD + `/${item.Id}`, body, options)
			.pipe(catchError(handleError));
		return items$;
	}

	deleteFacultyMandatoryCPD(item: FacultyMandatoryCPD): Observable<FacultyMandatoryCPD> {
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };

		let items$ = this.http
			.delete<FacultyMandatoryCPD>(API_URLS.API_FACULTY_MANDATORY_CPD + `/${item.Id}`, options)
			.pipe(catchError(handleError));
		return items$;
	}
}

// this could also be a private method of the component class
function handleError(error: HttpErrorResponse) {
	// log error
	// could be something more sofisticated
	console.error(error);

	return observableThrowError(error.error);
}
